const coalFormatter = new Intl.NumberFormat("en-NG", { maximumFractionDigits: 0 });

/** 50000 → "₦C 50,000". Coal Cash is always whole units. */
export function formatCoal(amount: number): string {
  return `₦C ${coalFormatter.format(amount)}`;
}

/** Short, human passport number derived from the public character uid. */
export function passportNumber(uid: string): string {
  return `CCL-${uid.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
}